<div id="alert" class="flex justify-between items-center">
  <span [ngClass]="classes">
    @if (isMessage()) {
      <mat-icon class="mr-2">feedback</mat-icon>
    }

    @if (isSuccess()) {
      <mat-icon class="mr-2">check_circle</mat-icon>
    }

    @if (isError()) {
      <mat-icon class="mr-2">error</mat-icon>
    }

    <span>{{ inject() }}</span>
  </span>
  <!-- <button mat-button></button> -->
</div>